/**
 * @deprecated Cette énumération est dépréciée, utilisez `PaymentMethod` à la place.
 */
export enum UserTypology {
  CB = 'CB',
  SEPA = 'SEPA',
  OFFLINE = 'OFFLINE',
  INIT_TRANSFERT_IMMEDIATE = 'INIT_TRANSFERT_IMMEDIATE',
  INIT_TRANSFERT_DEFERRED = 'INIT_TRANSFERT_DEFERRED',
}
